import * as React from 'react';
import { connect } from 'react-redux';

import { getRankingByTeamId, getNumberOfTeams, RanksByPlayerId } from '../reducers/statsRanking';
import {getActiveChannelId} from "../reducers/gui";
import {getMatchIdByChannelId} from "../reducers/timings";
import {getPlayerUidsByMatchId} from "../reducers/matches";
import {getRankAccordingToPlayerId} from "../reducers/statsRanking";

import StatsRankingPresentation from '../presentations/StatsRanking/StatsRankingPresentation'
import { getTranslations } from '../reducers/translations';

const mapStateToProps = (state: any) => {
    const channelId = getActiveChannelId(state);
    const matchId = getMatchIdByChannelId(state, channelId);
    const playerUids = getPlayerUidsByMatchId(state, matchId);
    const ranksByPlayerIds: RanksByPlayerId = getRankAccordingToPlayerId(state);

    return ({
        rankHome: ranksByPlayerIds && ranksByPlayerIds[playerUids['home']] ? ranksByPlayerIds[playerUids['home']].rank : null,
        rankAway: ranksByPlayerIds && ranksByPlayerIds[playerUids['away']] ? ranksByPlayerIds[playerUids['away']].rank : null,
        numRows: getNumberOfTeams(state),
        translations: getTranslations(state),
    });
}

export default connect( mapStateToProps )( StatsRankingPresentation );
